import { Card, Divider, Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { format } from "date-fns";
import { useGetUserInfo } from "hooks/useGetUserInfo";

interface TransactionReceiptProps {
    transaction: {
        user: string;
        package: {
            name: string;
        };
        plan_duration: string;
        trans_ref: string;
        amount: number;
        currency: string;
        gateway: string;
        payment_reference: string;
        created_at: string;
    };
}

export const TransactionReceipt = ({ transaction }: TransactionReceiptProps) => {
    const { userInfo } = useGetUserInfo();
    const user = userInfo?.name;
    return (
        <Card className="bg-white rounded-lg shadow-lg max-w-2xl mx-auto">
            <div className="text-center mb-6">
                <h1 className="text-2xl font-bold text-primary">Transaction Receipt</h1>
                <p className="text-gray-500">Payment confirmation for your subscription</p>
            </div>

            <Divider className="my-4" />

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <div className="space-y-2">
                    <DetailItem label="User" value={user} />
                    <DetailItem label="Package Name" value={transaction.package.name} />
                    <DetailItem
                        label="Plan Duration"
                        value={transaction.plan_duration.charAt(0).toUpperCase() + transaction.plan_duration.slice(1)}
                    />
                </div>

                <div className="space-y-2">
                    <DetailItem label="Transaction Date" value={format(new Date(transaction.created_at), "PPp")} />
                    <DetailItem label="Transaction Reference" value={transaction.trans_ref} />
                    <DetailItem label="Payment Reference" value={transaction.payment_reference} />
                </div>
            </div>

            <Divider className="my-4" />

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                {/* <DetailItem
                    label="Amount Paid"
                    value={
                        <span className="text-xl font-bold text-green-600">
                            <CurrencyFormatter value={amount} currency={currency} decimalPrecision={2} />
                        </span>
                    }
                /> */}
                <DetailItem label="Payment Gateway" value={transaction.gateway} />
            </div>

            <Divider className="my-4" />

            <div className="mt-6 text-center">
                <p className="text-gray-500 text-sm mb-4">
                    This receipt serves as confirmation of your payment.
                    Please keep this information for your records.
                </p>

                <Button
                    type="primary"
                    icon={<DownloadOutlined />}
                    className="bg-primary hover:bg-primary-dark"
                    onClick={() => window.print()}
                >
                    Download Receipt
                </Button>
            </div>
        </Card>
    );
};

const DetailItem = ({ label, value }: { label: string; value: React.ReactNode }) => (
    <div className="flex justify-between items-center">
        <span className="text-gray-600 font-medium">{label}:</span>
        <span className="text-accent">{value || 'N/A'}</span>
    </div>
);